import { render, staticRenderFns } from "./PosVendas.vue?vue&type=template&id=d1e18448&scoped=true&"
import script from "./PosVendas.vue?vue&type=script&lang=js&"
export * from "./PosVendas.vue?vue&type=script&lang=js&"
import style0 from "./PosVendas.vue?vue&type=style&index=0&id=d1e18448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e18448",
  null
  
)

export default component.exports